import React, { useState, useEffect } from "react";
import Layout from "../../General/Layout";
import Grid from "@mui/material/Grid";
import BasicCard from "../../General/Cards/BasicCard";
import { tableMap } from "./map";
import TabWrapper from "../../General/Tabs/TabWrapperForGrade";
import {
  IStudentTypesGOT,
  IReportResultTimeLines,
} from "../../Modals/GradeOverTime";
import { searchReport } from "../../Actions/generalActions";
import { useParams } from "react-router-dom";
import DownloadAsExcel from "../../General/Buttons/DownloadAsExcel";
import { downloadReport } from "../../Actions/downloadReportAction";

const Index = () => {
  const [tableData, setTableData] = React.useState<IStudentTypesGOT>();
  const [tableHeaderData, setHeaderTableData] =
    React.useState<IReportResultTimeLines[]>();
  const [reportData, setReportData] = React.useState<any>();
  const { id } = useParams();

  useEffect(() => {
    if (id) searchReport(id, setTableData, setHeaderTableData, setReportData);
  }, [id]);

  return (
    <Layout isBreadCrumHidden={true}>
      <Grid lg={12}>
        {tableData ? (
          <BasicCard heading="Grade Over Time">
            <DownloadAsExcel
              primaryFunction={() =>
                downloadReport(reportData.id, "Grade Over Time Report.xlsx")
              }
            />
            <TabWrapper
              tableMap={tableMap.slice(0, 3 + reportData.frequenceyNumber * 2)}
              tableData={tableData}
              downloadAsExcel="Download as Excel"
              tableHeaderData={tableHeaderData}
              isBaselineUploaded = {(reportData.isBaselineUploaded == true || reportData.baselineFileId !=null ? true:false) }
              reportType={reportData.frequenceyType}
              startDate={reportData.startDate}
            />
          </BasicCard>
        ) : (
          <></>
        )}
      </Grid>
    </Layout>
  );
};

export default Index;
